import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card px-6" }
const _hoisted_2 = { class: "card-body pt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px bg-bullet" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column justify-content-center align-items-center h-100"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "png/icons/ticket.png",
    alt: "profile"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HeaderTitle = _resolveComponent("HeaderTitle")!
  const _component_DetailItem = _resolveComponent("DetailItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderTitle, {
      title: _ctx.$t('platformsInfo.tasks'),
      subtitle: _ctx.subtitle
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: { name: 'platform_targets' },
          class: "btn btn-sm btn-light"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("platformsInfo.ViewAll")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task, index) => {
        return (_openBlock(), _createBlock(_component_DetailItem, {
          key: index,
          title: task.title,
          subtitle: ` ${
            _ctx.$t('platformsInfo.dueIn') + ' ' + task.dueDate.split('T')[0]
          } `,
          lead: task.assignedUser.firstName + ' ' + task.assignedUser.lastName,
          class: "mb-4"
        }, {
          left: _withCtx(() => [
            _hoisted_3
          ]),
          _: 2
        }, 1032, ["title", "subtitle", "lead"]))
      }), 128)),
      (_ctx.tasks && !_ctx.tasks.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary mt-4",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChangeStateModal && _ctx.handleChangeStateModal(...args)))
            }, _toDisplayString(_ctx.$t("platformsInfo.createTicket")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}